<ng-container *ngIf="hasData; else emptyState">
	<section class="section-header">
		<div class="header-content">
			<div class="header-left">
				<i class="fa-solid fa-building-columns"></i>
				<div class="header-text">
					<h1>Flujos Bancarios del Titular</h1>
					<p class="header-subtitle">Información de cuentas, períodos y saldos del cliente</p>
				</div>
			</div>
			<div class="header-right">
				<div class="hero-stat" *ngIf="averageCashFlow !== null">
					<i class="fa-solid fa-droplet"></i>
					<div class="hero-stat-content">
						<span class="hero-stat-label">Flujo de liquidez promedio (Excel)</span>
						<span class="hero-stat-value">{{ averageCashFlow | currency:'MXN':'symbol-narrow':'1.2-2' }}</span>
					</div>
				</div>
				<p-tag [value]="holderFlows.length + (holderFlows.length === 1 ? ' cuenta' : ' cuentas')" severity="info"></p-tag>
			</div>
		</div>
	</section>

	<section class="info-card" *ngFor="let flow of holderFlows; let i = index">
		<div class="card-header">
			<i class="fa-solid fa-building-columns"></i>
			<h3>
				{{ flow.name }}
				<span class="account-number" *ngIf="flow.account">· {{ flow.account }}</span>
			</h3>
			<div class="header-tags">
				<p-tag [value]="flow.currency" [severity]="flow.currency === 'USD' ? 'info' : 'success'"></p-tag>
				<p-tag *ngIf="flow.exchangeRate" [value]="'T.C. ' + (flow.exchangeRate | number:'1.2-4')" severity="secondary"></p-tag>
				<p-tag *ngIf="flow.generalAverage !== null && flow.generalAverage !== undefined"
					[value]="'Promedio: ' + (flow.generalAverage | currency:flow.currency:'symbol-narrow':'1.0-0')"
					severity="secondary">
				</p-tag>
			</div>
		</div>
		<div class="card-content">
			<table class="data-table">
				<thead>
					<tr>
						<th>Periodo</th>
						<th class="num">Saldo inicial</th>
						<th class="num">Depósitos (+)</th>
						<th class="num">Cargos (−)</th>
						<th class="num">Saldo promedio</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let bal of flow.balances">
						<td>{{ bal.date | date:'mediumDate' }}</td>
						<td class="num">{{ bal.initialBalance | currency:flow.currency:'symbol-narrow':'1.2-2' }}</td>
						<td class="num">{{ bal.deposits | currency:flow.currency:'symbol-narrow':'1.2-2' }}</td>
						<td class="num">{{ bal.charges | currency:flow.currency:'symbol-narrow':'1.2-2' }}</td>
						<td class="num">{{ bal.averageBalance | currency:flow.currency:'symbol-narrow':'1.2-2' }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</section>
</ng-container>

<ng-template #emptyState>
	<div class="empty-state">
		<i class="fa-solid fa-file-arrow-up"></i>
		<h3>Sin datos de flujos del titular</h3>
		<p>Sube el Excel de Análisis de Riesgo arriba para ver los flujos bancarios del cliente.</p>
	</div>
</ng-template>
